<template>
    <div class="vehicle-shortlist-page page" style="max-width: 900px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Vehicle Shortlist</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div class="d-flex justify-content-between mb-3">
                <button @click="backToSearch"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi mdi-car"/>
                    Back to Search
                </button>
                <button @click="clearList"
                        class="btn btn-danger waves-effect waves-light"
                        v-if="vehicles.data.length"
                        type="button">
                    <i class="mdi mdi-delete"/>
                    Clear List
                </button>
            </div>
            <p class="my-3 ml-2" v-if="!vehicles.meta.fetched && vehicles.meta.loading">Loading...</p>
            <div class="row">
                <div
                    :class="{ 'col-6' : !is_mobile }"
                    class="col px-1"
                    v-for="vehicle in vehicles.data"
                >
                    <vehicle-item
                        :key="vehicle.id"
                        :vehicle="vehicle"
                        @removedFromShortlist="removeFromShortlist"
                        class="vehicle-border-under"
                    />
                </div>
            </div>

            <p class="my-3 ml-2" v-if="!vehicles.data.length && vehicles.meta.fetched">No shortlist item.</p>
        </div>
    </div>
</template>

<script>
    import Routes from "@/constants/routes";
    import VehicleModel from "@/models/vehicle";
    import ArrayUtils from "@/utils/array";
    import VehicleItem from "@/components/main/VehicleItem";

    export default {
        components: {
            VehicleItem
        },
        data() {
            return {
                vehicles: {
                    data: [],
                    meta: {
                        fetched: false,
                        loading: false,
                        pagination: null
                    }
                },
            }
        },
        created() {
            this.initShortlists();
        },
        methods: {
            initShortlists() {
                this.vehicles.meta.loading = true;
                VehicleModel.shortlisted()
                    .then((response) => {
                        this.vehicles.data = response.data;
                        this.vehicles.meta.pagination = response.meta;
                        this.vehicles.meta.fetched = true;
                        this.vehicles.meta.loading = false;
                    })
            },
            backToSearch() {
                this.$router.push({
                    name: Routes.vehicle
                })
            },
            removeFromShortlist(vehicle) {
                let existing = _.find(this.vehicles.data, {id: vehicle.id});
                if (existing) {
                    ArrayUtils.delete(this.vehicles.data, existing);
                }
            },
            clearList() {
                this.$confirm('Are you sure you want to clear the vehicle shortlist?', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    VehicleModel.clearShortlist()
                        .then(() => {
                            this.vehicles.data = [];
                            this.vehicles.meta.pagination = null;
                            this.vehicles.meta.loading = false;
                            this.$notify({
                                title: 'Success',
                                message: 'Successfully cleared shortlist.',
                                type: 'success'
                            });
                        })
                });
            }
        }
    }
</script>

<style scoped>

</style>
